document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    if (menu) menu.hidden = open;
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const idInput = form && form.querySelector('[name="id"]');
  const price = document.querySelector('[data-product-price]');
  const button = form && form.querySelector('[type="submit"]');
  if (idInput) idInput.value = select.value;
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.disabled;
    button.textContent = option.disabled ? 'Sold out' : 'Add to cart';
  }
});
